import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import "./UrlFiltersInfobar.scss";
import { NotMobile } from "../../../../hocs/Responsive";
import { HelpLink } from "../../../../components/helpLink/HelpLink";

export const UrlFiltersInfobar = ({ className, children }) => (
  <div className={classnames("url-filters-infobar", className)}>
    <NotMobile>
      <div className="infobar__tip">
        <p>
          <FormattedMessage id="url_filters_description" />
        </p>
        <HelpLink section={"blocking-content-by-url"}>
          <FormattedMessage id="online_help" />
        </HelpLink>
      </div>
      <div className="infobar__content">{children}</div>
    </NotMobile>
  </div>
);
